import { useQuery } from "@tanstack/react-query";

import { api } from "../api/rest";
import { CexDepthPanel } from "../components/CexDepthPanel";
import { LatencyPanel } from "../components/LatencyPanel";
import { LiveFeed } from "../components/LiveFeed";
import { MarketsPanel } from "../components/MarketsPanel";
import { OrdersPanel } from "../components/OrdersPanel";
import { RebatesTile } from "../components/RebatesTile";
import { StatusPanel } from "../components/StatusPanel";
import { TapePanel } from "../components/TapePanel";
import { useStatus } from "../hooks/useStatus";

export function Dashboard() {
  // Общий хук, а не свой useQuery: на статус смотрят ещё кнопка стопа в шапке и
  // форма ордера, а TanStack Query дедуплицирует опрос по ключу.
  const status = useStatus();

  const markets = useQuery({
    queryKey: ["markets"],
    queryFn: api.markets,
    refetchInterval: 30_000,
  });

  return (
    <div className="grid gap-4 lg:grid-cols-[1fr_minmax(0,420px)]">
      <div className="flex flex-col gap-4">
        <StatusPanel
          status={status.data}
          error={status.error as Error | null}
          loading={status.isLoading}
        />
        <MarketsPanel
          markets={markets.data?.markets ?? []}
          error={markets.error as Error | null}
          loading={markets.isLoading}
        />
        {/* Токены всех рынков — только ради исхода в строках ордеров
            («BUY UP»): секции позиции на дашборде нет. */}
        <OrdersPanel
          conditionId={null}
          tokens={markets.data?.markets.flatMap((m) => m.tokens)}
        />
      </div>

      <div className="flex flex-col gap-4">
        {/* Тир возврата — рядом со статусом по той же причине, по которой там
            задержка: это тоже «как система себя чувствует», только в деньгах.
            Ступень теряют МОЛЧА — объём вытекает из скользящего окна сам, — и
            число обязано попадаться на глаза без перехода в раздел. */}
        <RebatesTile />
        {/* Разбор задержки живёт рядом со статусом: это страница «как система
            себя чувствует», и артефакт приёмки вехи M5 снимают именно с неё. */}
        <LatencyPanel />
        {/* Плотность стакана биржи расчёта. Рядом со счётчиком ленты, потому
            что отвечает на соседнюю половину вопроса: лента говорит, сколько
            прошло по Polymarket, а этот блок — чем подпёрта цена, по которой
            окно решится. Связи между ними НЕТ (она измерена), и панель этого
            не утверждает. */}
        <CexDepthPanel />
        <TapePanel conditionId={null} />
        <LiveFeed />
      </div>
    </div>
  );
}
